module.exports = ({
    "CDMS800TT001": "รายงานประวัติผู้ใช้งาน",
    "CDMS800H001": "ข้อมูลองค์กร",
    "CDMS800H002": "ประเทศ",
    "CDMS800H003": "องค์กร",
    "CDMS800H004": "ข้อมูลผู้ใช้",
    "CDMS800H005": "รหัสผู้ใช้งาน",
    "CDMS800H006": "ชื่อผู้ใช้งาน",
    "CDMS800H007": "ข้อมูลการศึกษา",
    "CDMS800H008": "ตำแหน่ง",
    "CDMS800H009": "รหัสสถานวิจัย",
    "CDMS800H010": "ชื่อสถานวิจัย",
    "CDMS800H011": "วันและเวลา",
    "CDMS800H012": "สถานะ",
    "CDMS800OPT001": "Active",
    "CDMS800OPT002": "Inactive"
});
